module.exports = __webpack_public_path__ + "img/qy (42).2a126ba6.jpg";